import { MARQUEE_ITEMS } from "@/data/content";
import { ShieldCheck } from "lucide-react";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className="bg-emerald-950 border-y border-emerald-900/60 py-3.5 overflow-hidden"
      data-testid="trust-marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {items.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-3 px-8 text-[11px] sm:text-xs tracking-[0.25em] uppercase font-medium text-emerald-100/90"
          >
            <ShieldCheck className="w-3.5 h-3.5 text-amber-400/90 shrink-0" />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
